export interface Category {
  id: string;
  nameKey: string;
  href: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    nameKey: "category.shoes",
    href: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20premium%20white%20and%20tan%20running%20sneaker%20photographed%20from%20a%20three%20quarter%20angle%20on%20a%20warm%20terracotta%20clay%20colored%20studio%20backdrop%2C%20soft%20directional%20window%20light%20casting%20a%20long%20gentle%20shadow%2C%20editorial%20product%20photography%20with%20rich%20earthy%20tones%2C%20high%20detail%2C%20crisp%20and%20airy%20composition%20with%20generous%20negative%20space&width=800&height=800&seq=cat-shoes-01&orientation=squarish&nocache=true",
  },
  {
    id: "hoodies",
    nameKey: "category.hoodies",
    href: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20relaxed%20sage%20green%20hoodie%20hanging%20on%20a%20natural%20wooden%20hanger%20against%20a%20soft%20sage%20tinted%20studio%20wall%2C%20diffused%20morning%20light%2C%20subtle%20shadows%2C%20minimalist%20apparel%20editorial%20photography%2C%20calm%20botanical%20mood%2C%20high%20detail%2C%20clean%20harmonious%20composition&width=800&height=800&seq=cat-hoodies-02&orientation=squarish&nocache=true",
  },
  {
    id: "tshirts",
    nameKey: "category.tshirts",
    href: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20folded%20stack%20of%20pastel%20cotton%20t-shirts%20in%20soft%20pink%2C%20mint%20and%20cream%20resting%20on%20a%20light%20sand%20colored%20surface%2C%20flat%20lay%20style%20with%20soft%20overhead%20light%2C%20gentle%20shadows%2C%20editorial%20apparel%20photography%2C%20fresh%20and%20airy%20with%20generous%20negative%20space%2C%20high%20detail&width=800&height=800&seq=cat-tshirts-03&orientation=squarish&nocache=true",
  },
  {
    id: "jackets",
    nameKey: "category.jackets",
    href: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20structured%20camel%20wool%20overcoat%20standing%20upright%20on%20an%20invisible%20mannequin%20against%20a%20warm%20oat%20colored%20studio%20background%2C%20soft%20studio%20lighting%20with%20gentle%20shadow%2C%20luxury%20editorial%20fashion%20photography%2C%20refined%20minimalist%20mood%2C%20high%20detail&width=800&height=800&seq=cat-jackets-04&orientation=squarish&nocache=true",
  },
  {
    id: "pants",
    nameKey: "category.pants",
    href: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20relaxed%20fit%20stone%20grey%20cargo%20pants%20neatly%20folded%20with%20visible%20fabric%20texture%20on%20a%20pale%20concrete%20studio%20surface%2C%20soft%20natural%20side%20light%2C%20subtle%20shadows%2C%20editorial%20apparel%20product%20photography%2C%20understated%20modern%20aesthetic%2C%20high%20detail&width=800&height=800&seq=cat-pants-05&orientation=squarish&nocache=true",
  },
  {
    id: "headwear",
    nameKey: "category.headwear",
    href: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-vip-crown-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20classic%20washed%20navy%20cap%20with%20embroidered%20detail%20resting%20on%20a%20soft%20blush%20pink%20studio%20backdrop%2C%20diffused%20soft%20light%2C%20delicate%20shadow%2C%20editorial%20accessory%20product%20photography%2C%20fresh%20pastel%20aesthetic%20with%20generous%20negative%20space%2C%20high%20detail&width=800&height=800&seq=cat-headwear-06&orientation=squarish&nocache=true",
  },
  {
    id: "sets",
    nameKey: "category.sets",
    href: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20hoodie%20and%20jogger%20set%20in%20warm%20oatmeal%20tones%20folded%20side%20by%20side%20on%20a%20light%20linen%20studio%20surface%2C%20soft%20diffused%20daylight%2C%20gentle%20shadows%2C%20editorial%20loungewear%20photography%2C%20cozy%20minimalist%20mood%2C%20high%20detail&width=800&height=800&seq=cat-sets-07&orientation=squarish&nocache=true",
  },
  {
    id: "underwear",
    nameKey: "category.underwear",
    href: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20underwear%20in%20neutral%20heather%20grey%20folded%20neatly%20on%20a%20crisp%20white%20textured%20studio%20surface%2C%20bright%20clean%20light%20with%20soft%20shadows%2C%20editorial%20basics%20product%20photography%2C%20fresh%20hygienic%20minimalist%20aesthetic%2C%20high%20detail&width=800&height=800&seq=cat-underwear-08&orientation=squarish&nocache=true",
  },
  {
    id: "jersey",
    nameKey: "category.jersey",
    href: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20bold%20athletic%20football%20jersey%20in%20deep%20emerald%20and%20gold%20laid%20flat%20on%20a%20soft%20stone%20grey%20studio%20background%2C%20directional%20soft%20light%20with%20gentle%20shadow%2C%20editorial%20sportswear%20product%20photography%2C%20clean%20and%20dynamic%20composition%2C%20high%20detail&width=800&height=800&seq=cat-jersey-09&orientation=squarish&nocache=true",
  },
  {
    id: "accessories",
    nameKey: "category.accessories",
    href: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20curated%20flat%20lay%20of%20minimalist%20accessories%20including%20a%20leather%20watch%2C%20slim%20sunglasses%20and%20a%20metal%20keychain%20on%20a%20warm%20caramel%20studio%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20refined%20warm%20aesthetic%20with%20generous%20negative%20space%2C%20high%20detail&width=800&height=800&seq=cat-accessories-10&orientation=squarish&nocache=true",
  },
  {
    id: "bags",
    nameKey: "category.bags",
    href: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20structured%20moss%20green%20canvas%20tote%20bag%20with%20leather%20handles%20standing%20upright%20on%20a%20soft%20cream%20platform%20against%20a%20pale%20olive%20studio%20wall%2C%20soft%20diffused%20light%2C%20editorial%20accessory%20photography%2C%20organic%20earthy%20aesthetic%2C%20high%20detail&width=800&height=800&seq=cat-bags-11&orientation=squarish&nocache=true",
  },
  {
    id: "belts",
    nameKey: "category.belts",
    href: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-wallet-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20handcrafted%20tan%20leather%20belt%20coiled%20elegantly%20beside%20a%20brass%20buckle%20on%20a%20warm%20walnut%20wood%20studio%20surface%2C%20soft%20directional%20light%20with%20gentle%20shadow%2C%20editorial%20accessory%20product%20photography%2C%20rich%20natural%20aesthetic%2C%20high%20detail&width=800&height=800&seq=cat-belts-12&orientation=squarish&nocache=true",
  },
  {
    id: "perfumes",
    nameKey: "category.perfumes",
    href: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-flask-line",
    image:
      "https://readdy.ai/api/search-image?query=An%20elegant%20amber%20glass%20perfume%20bottle%20with%20a%20minimal%20label%20on%20a%20soft%20ivory%20podium%20against%20a%20warm%20golden%20studio%20backdrop%2C%20soft%20rim%20lighting%20with%20delicate%20shadow%2C%20luxury%20editorial%20product%20photography%2C%20high%20detail%2C%20refined%20and%20airy&width=800&height=800&seq=cat-perfumes-13&orientation=squarish&nocache=true",
  },
  {
    id: "other",
    nameKey: "category.other",
    href: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-box-3-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20tidy%20collection%20of%20assorted%20everyday%20lifestyle%20goods%20including%20a%20water%20bottle%2C%20folded%20socks%20and%20a%20notebook%20arranged%20on%20a%20warm%20amber%20studio%20surface%2C%20soft%20overhead%20light%2C%20editorial%20product%20photography%2C%20cheerful%20fresh%20aesthetic%20with%20generous%20negative%20space%2C%20high%20detail&width=800&height=800&seq=cat-other-14&orientation=squarish&nocache=true",
  },
];

export const mainSiteUrl = "https://kaspreadsheet.com";

export const heroImage =
  "https://readdy.ai/api/search-image?query=A%20vibrant%20editorial%20flat%20lay%20of%20assorted%20fashion%20items%20including%20sneakers%2C%20a%20denim%20jacket%2C%20a%20tote%20bag%20and%20accessories%20arranged%20artfully%20on%20a%20warm%20sand%20colored%20surface%20with%20soft%20directional%20light%20and%20long%20shadows%2C%20fresh%20modern%20retail%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition%20with%20generous%20negative%20space&width=1600&height=900&seq=hero-2026-01&orientation=landscape&nocache=true";